// CARDS
import styles from "./card.module.scss";

export const CardHeading = (props: any) => (
  <div className={`${props.className || ""} ${styles.card_heading}`} style={props.style || {}}>
    {props.children}
  </div>
);

export const Card = (props: any) => (
  <div className={`${props.className || ""} ${styles.card_component}`} style={props.style || {}} id={props.id}>
    {props.children}
  </div>
);
